<template>
  <div class="DeveloperLocationMap">
    <h6 class="DeveloperLocationMap__section-heading">Developer Location</h6>
    <div v-if="developerCountry" class="map-container">
      <div id="developerMap" ref="map"></div>
    </div>
    <div v-else class="DeveloperLocationMap__placeholder">
      <the-icon icon="developers" class="mr-2" />
      Location not specified
    </div>
  </div>
</template>

<script>
import svgMap from 'svgmap'
import 'svgmap/dist/svgMap.min.css'

export default {
  name: 'DeveloperLocationMap',
  props: {
    developerCountry: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (this.developerCountry) {
      this.$nextTick(() => {
        this.initMap()
      })
    }
  },
  watch: {
    developerCountry() {
      if (this.developerCountry) {
        this.$nextTick(() => {
          this.initMap()
        })
      }
    }
  },
  methods: {
    initMap() {
      // Clear any existing map
      const mapElement = document.getElementById('developerMap')
      if (mapElement) {
        mapElement.innerHTML = ''
      }

      // Create data object with the developer's country highlighted
      const mapData = {}
      if (this.developerCountry) {
        mapData[this.developerCountry] = {
          developers: 1
        }
      }

      new svgMap({
        targetElementID: 'developerMap',
        mouseWheelZoomEnabled: false,
        hideFlag: true,
        data: {
          data: {
            developers: {
              format: '{0}',
              thousandSeparator: ',',
              thresholdMax: 1,
              thresholdMin: 1,
            },
          },
          applyData: 'developers',
          values: mapData,
        },
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.DeveloperLocationMap {
  &__section-heading {
    color: white;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 24px;
    font-weight: normal;
  }

  &__placeholder {
    display: flex;
    align-items: center;
    color: $N2;
    font-size: 14px;
    font-style: italic;
    padding: 8px 12px;
    background: rgba($N2, 0.1);
    border: 1px dashed rgba($N2, 0.3);
    border-radius: 4px;
    margin: 4px 0;
    
    .the-icon {
      color: $N2;
      fill: $N2;
      opacity: 0.7;
    }
  }
}

.map-container {
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
}

#developerMap {
  height: 100%;
  
  .svgMap-map-wrapper {
    background: $N4;
  }
  
  .svgMap-map-image {
    background: $N4 !important;
  }
  
  .svgMap-map-wrapper .svgMap-map-image {
    background: $N4 !important;
  }
}

// Override svgMap styles for consistency
:deep(.svgMap-tooltip) {
  background: rgba(31, 41, 55, 0.9);
  box-shadow: 0px 4px 8px rgba(24, 33, 45, 0.4);
  border-radius: 11px;
  color: #ffffff !important;
  font-family: inherit;
}

:deep(.svgMap-map-wrapper) {
  background: $N4 !important;
}

:deep(.svgMap-map-image) {
  background: $N4 !important;
}

:deep(.svgMap-map-wrapper .svgMap-map-image) {
  background: $N4 !important;
}

:deep(.svgMap-tooltip .svgMap-tooltip-content-wrapper) {
  color: #ffffff !important;
}

:deep(.svgMap-tooltip .svgMap-tooltip-content .svgMap-tooltip-no-data) {
  color: #ffffff !important;
}

:deep(.svgMap-tooltip .svgMap-tooltip-content) {
  color: #ffffff !important;
}

:deep(.svgMap-tooltip .svgMap-tooltip-content table td span) {
  color: #ffffff;
}

:deep(.svgMap-tooltip-pointer) {
  display: none;
}
</style> 